import { User } from "../@core/data/users";
import { Person } from "./person.model";

export class Customer {
  id?: string;
  email?: string;
  mobile?: string;
  cardId?: string;
  cardIdDate?: Date;
  cardIdPlace?: string;

  fullName?: string;
  firstName?: string;
  lastName?: string;
  dob?: Date;
  dobYear?: number;
  dobMonth?: number;
  dobDay?: number;
  gender?: string;
  address?: string;
  description?: string;
  tax?: string;

  tags?: string[];
  coverUrl?: string;

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images
  isDefault?: boolean;

  //List contacts
  contacts?: CustomerContacts[];

  discountPolicies?: DiscountPolicy[];

  assignBy?: string;
  assignName?: string;
  assignee?: User;

  //Overview
  saleQuantity?: number;
  saleAmount?: number;
  paidAmount?: number;
  debitAmount?: number;
  profitAmount?: number;
  noHistory?: number;
  totalQuantity?: number;
  totalInvoices?: number;
  totalAmount?: number;

  initAmount?: number;
  lastAmount?: number;

  isSynced?: boolean;
  syncedOn?: Date;

  hadChange?: boolean;

  shopId?: string;
  shopIdArchived?: string;
  isArchived?: boolean;
  archivedId?: string;
  isInitDept?: boolean;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class CustomerContacts {
  id?: string;
  role?: string;
  description?: string;
  person?: Person;

  //default
  timestamp?: number;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
}

export class DiscountPolicy {
  // groupId?: string;
  // groupName?: string;
  categoryId?: string;
  categoryName?: string;
  discountPercent?: number;
  createdOn?: Date;
}

export class CustomerStats {
  id?: string;

  mode?: string; //[day, month, year]
  issueDate?: Date;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  customerId?: string;
  customerName?: string;
  customerMobile?: string;
  customerAddress?: string;

  //Overview
  saleAmount?: number;
  paidAmount?: number;

  debitAmount?: number; // = initAmount + saleAmount - paidAmount
  profitAmount?: number; // = saleAmount - paidAmount

  initAmount?: number;
  lastAmount?: number;
  firstReceiptDate?: Date;
  lastReceiptDate?: Date;
  totalAmount?: number; // = initAmount + saleAmount
  totalInvoices?: number;

  isArchived?: boolean;

  isSynced?: boolean;
  syncedOn?: Date;

  shopId?: string;
  shopIdArchived?: string;
  //default
  timestamp?: number;
  createdOn?: Date;
  updatedOn?: Date;
}
